import * as core from '../../../../../../../core'
import * as engagementCharterComponentKind from '../engagement-charter-component-kind'

export const RESOURCE = {
  payload: {
    description: 'The component is a business-development note.',
    enumId: core.dms.models.Enum.Id.from({
      partialId: engagementCharterComponentKind.RESOURCE.payload.partialId,
    }),
    id: 'BD_NOTE',
    name: 'BD Note',
  },
  type: core.quiver.Resource.Type.DmsEnumEntry,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsEnumEntry>
